export const platformStats = `
query MyQuery {
  integratedPlatformStats {
    name
    id
    count
  }
}
`